import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import swedish from './default/swedish.json';
import english from './default/english.json';

i18n.use(initReactI18next)
    .init({
        resources: {
            en: {
                default: english
            },
            sv: {
                default: swedish
            }
        },
        fallbackLng: "en",
        debug: true,

        ns: ["default"],
        defaultNS: "default",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;